module.exports = __webpack_public_path__ + "img/11passenger_driving.32da2077.svg";